import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';

export class DownloadPackage implements ViewModel {
  friendlyTypeNameSingular: string;
  apiRoute: string;
  fileExtension: string;

  modelId: string;
  name: string;
  metadata: string | ArrayBuffer;
  packageType: PackageType;

  constructor() {
    this.metadata = '';
    this.name = '';
    this.modelId = CONFIG.constants.emptyGuid;
    this.packageType = PackageType.Unknown;
  }

  json() {
    return this;
  }
  loadFromJson(data: any) {
    this.name = data.name;
    this.metadata = data.metadata;
    this.modelId = data.modelId;
  }
}

export class ModelPackage extends DownloadPackage {
  constructor() {
    super();
    this.friendlyTypeNameSingular = 'Model Package';
    this.apiRoute = CONFIG.apiRoutes.modelPackage;
    this.fileExtension = CONFIG.fileExtensions.modelPackage;
    this.packageType = PackageType.Model;
  }
}

export class ModelLookupPackage extends DownloadPackage {
  constructor() {
    super();
    this.friendlyTypeNameSingular = 'Model Lookups Package';
    this.apiRoute = CONFIG.apiRoutes.modelLookupsPackage;
    this.fileExtension = CONFIG.fileExtensions.lookupsPackage;
    this.packageType = PackageType.Lookups;
  }
}

export class LookupPackage extends DownloadPackage {
  constructor() {
    super();
    this.friendlyTypeNameSingular = 'Lookup Package';
    this.apiRoute = CONFIG.apiRoutes.lookupPackage;
    this.fileExtension = CONFIG.fileExtensions.lookupsPackage;
    this.packageType = PackageType.Lookups;
  }
}

export enum PackageType {
  Unknown,
  Model,
  Lookups,
  Rcm,
}
